<template>
	<div>
		<buttonlist @help="help" @exps="exps"  @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-date-picker
					v-model="Month"
					value-format="yyyy-MM"
					type="month">
					</el-date-picker>
					<el-button type="primary" size="mini"  @click="send">{{$t('getapi[1980]')}}</el-button>
				</div>
			</div>
		</el-card> 
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<div id="xpane-0">
					<vxe-table
					:data="dataSet"
					v-loading="loading"
					border
					stripe
					resizable
					size="mini"
					:height="tableHeight"
					ref="singleTable"
				>
			<vxe-table-column show-overflow field="balance_year" :title="$t('getapi[1974]')" align="right" width='80'/>
			<vxe-table-column show-overflow field="balance_month" :title="$t('getapi[1975]')" align="right" width='80'/>
			<vxe-table-column show-overflow field="category_first_name" :title="$t('getapi[169]')"  width='150'/>
			<vxe-table-column show-overflow field="category_second_name" :title="$t('getapi[170]')"  width='150'/>
			<vxe-table-column show-overflow field="category_third_name" :title="$t('getapi[171]')"  width='150'/>
			<vxe-table-column show-overflow field="part_code" :title="$t('getapi[112]')"  width='150'/>
			<vxe-table-column show-overflow field="part_version" :title="$t('getapi[149]')"  width='80'/>
			<vxe-table-column field="init_qty" :title="$t('getapi[7299]')" align="right" width='100'>
				<template slot-scope="scope">
					{{scope.row.init_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_qty" :title="$t('getapi[1850]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_net_unit_price" :title="$t('getapi[4747]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_net_unit_price | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_total_material" :title="$t('getapi[7691]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_total_material | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_total_man" :title="$t('getapi[7692]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_total_material | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_total_charge" :title="$t('getapi[7693]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_total_material | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="issue_qty" :title="$t('getapi[7317]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.issue_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="Issue_Material_Cost" :title="$t('getapi[7694]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.Issue_Material_Cost | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="Issue_Man_Cost" :title="$t('getapi[7695]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.Issue_Man_Cost | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="Issue_Charge_Cost" :title="$t('getapi[7696]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.Issue_Charge_Cost | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="Issue_Material_Unit" :title="$t('getapi[7697]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.Issue_Material_Unit | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="Issue_Man_Unit" :title="$t('getapi[7698]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.Issue_Man_Unit | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="Issue_Charge_Unit" :title="$t('getapi[7699]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.Issue_Charge_Unit | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="remain_qty" :title="$t('getapi[7328]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.remain_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_sale_amount" :title="$t('getapi[7700]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_sale_amount | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="local_sale_unit" :title="$t('getapi[7701]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.local_sale_unit | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="receive_profit" :title="$t('getapi[7702]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.receive_profit | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="board" :title="$t('getapi[7703]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.board | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="chemical" :title="$t('getapi[7704]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.chemical | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column show-overflow field="other" :title="$t('getapi[224]')" align="right" width='150'>
				<template slot-scope="scope">
					{{scope.row.other | thousandth}}
				</template>
			</vxe-table-column>
			</vxe-table>   
				</div>
			</li>
		</ul>
			<!-- <el-row>
				<el-col :span="18">
					<el-pagination
						style="margin-top: 1em"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="100"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
				</el-col>
			</el-row> -->
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SalEstimateInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<!-- <ctable :isVisible="false" title="CSV" queryData="SalLogicticscsvViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable> -->
	
		<!-- 详情页面 -->
		<!-- <purordermanage :isVisible="isVisible" ref="order" @getdetail="getdetail"></purordermanage> -->
		<!-- 选择时间 -->
		<el-dialog v-dialogDrag :title="$t('getapi[6433]')" :visible.sync="dialogVisible" width="30%">
			<div class="bbl">
			<span>{{$t('getapi[6434]')}}</span>
			<el-date-picker v-model="copyparam.startMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<div class="bbl">
			<span>{{$t('getapi[6435]')}}</span>
			<el-date-picker v-model="copyparam.copyMonth" popper-class="select-option" type="month" value-format="yyyy-MM" size="mini"></el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="dialogVisible = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="copyconfirm">{{$t('getapi[1146]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_arecievec',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight-240,
                maxHeight: this.$windowSize.tableHeight-240,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
			viewurl:'/CostCalc/SaleView/GetReceiveSalDiffRateExView',
			expurl:'/CostCalc/SaleView/GetReceiveSalDiffRateExViewToExecl',
			Month:"",
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				send: false,
				print:false,
				//删除
				delete: false,
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                setTimeout(() => {
                    that.$processdata.initForm(0)
                }, 500);
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SalLogicticscsvViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6632]"),this.$t("getapi[8045]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);

			//that.$refs.SetBtn.SetButtonEnable('export',true);
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			return;

			// //只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 375, 1, that.total)) {
			// 	if (that.total > 0) {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 	} else {
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 	}
			// }
			// //操作权限-查询级别
			// limits = that.$limits.OperationAuthorityView('plv2', 375, 1, that.total);
			// // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			// switch (limits) {
			// 	case -1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 1:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 2:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	case -3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh');
			// 		break;
			// 	case 3:
			// 		that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			// 		break;
			// 	default:
			// 		break;
			// }
			// if(limits==-1||limits==1)that.closeAllRightButton();
            // else that.btnauthority();
		},
		btnauthority() {
			let that = this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
			
		},
		closeAllRightButton(){
			let that =this;
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		if(that.selectIDList.length>0){
			that.btn.send = true;
			that.btn.delete = true;
			that.btn.print = true;
		}else{
			that.btn.send = false;
			that.btn.delete = false;
			that.btn.print = false;
		}
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SalEstimateInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost(that.viewurl, data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		copyconfirm(){
			//  
			let that = this;
			that.btn.copy = false
			let parm = {
			"newmonth": that.copyparam.copyMonth.split("-")[1],
			"newyear": that.copyparam.copyMonth.split("-")[0],
			"oldmonth": that.copyparam.startMonth.split("-")[1],
			"oldyear": that.copyparam.startMonth.split("-")[0],
			}

			that.$http.urlpost('/Inv/PartCost/InvPartStdCostCopyCost', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
				that.btn.copy = true;
				that.dialogVisible = false;
			});


		},
		send(){
		let that = this;

		if(that.$limits.fnIsEmpty(that.Month))
		{
		that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
		return;
		}
		let datac ={
		TYear: that.Month.split('-')[0],
		Month:  that.Month.split('-')[1],
		};
		that.loading = true;
		//console.log(datac)
		that.$http.urlpost(that.viewurl, datac, function(res) {
		if (res.Success == 1) {
		that.dataSet = res.DataContent;
		}
		that.loading = false;
		});
		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			if(that.$limits.fnIsEmpty(that.Month))
			{
				that.$message.warning(that.$t('getapi[6086]'));//"请选择日期"
				return;
			}
			let datac ={
			TYear: that.Month.split('-')[0],
			Month:  that.Month.split('-')[1],
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[6632]')
			};
			that.$http.urlpost(that.expurl, datac, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		print(){
			let that = this;
			let parm = {
			po_no: '',
			TemplateName: '08Invoice_CSV.xlsx'
			};

			for(let i=0;i<that.selectIDList.length;i++){
			parm.po_no= parm.po_no + "'"+that.selectIDList[i].exclusively_id+"',";
			}
			parm.po_no =  parm.po_no.substring(0, parm.po_no.length - 1);

			that.btn.print = false;
			that.loading = true;
			that.$http.urlpost('/Print/CSVPrint', parm, function (res) {
			that.btn.print = true;
			if (res.Success == 1) {
			let hrefurl = res.Key;
			window.open(hrefurl);
			} 
			that.loading = false;
			});
		},
		deleteline(){
			let that = this;
			let parm = {
				Delivery_Note_N: that.selectIDList[0].Delivery_Note_N,
			};
			that.$http.urlpost('/Sal/Tru/DeleteCsv', parm, function(res) {
				if (res.Success == 1) {
					that.reflash();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
				}
			});

		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
